import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Button, Table, Accordion } from "react-bootstrap";
import axios from "axios";
import Receipt from "../Receipt.jsx";
import SummaryCard from "./SummaryCard.jsx";
import classes from "./AllExpendituresAnalysis.module.css";
import YesAndNoModal from "../Modals/YesAndNoModal.jsx";
import ReactExport from "react-export-excel-fixed-xlsx";
import PermissionContext from "../../../Store/permission-context";

const AllExpendituresAnalysis = (props) => {
  const PCtx = useContext(PermissionContext);
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  const [DisplayData, setDisplayData] = useState(true);
  const [ShowModal, setShowModal] = useState(false);
  const [IsPrinting, setIsPrinting] = useState(false);
  const [Message, setMessage] = useState("");
  const [TotalCash, setTotalCash] = useState(0);
  const [TotalPOS, setTotalPOS] = useState(0);
  const [TotalTransfer, setTotalTransfer] = useState(0);
  const [TotalExpenditure, setTotalExpenditure] = useState(0);
  const [ModalType, setModalType] = useState("");
  const [ReceiptToDelete, setReceiptToDelete] = useState({});
  const [ThisExpenditures, setThisExpenditures] = useState([]);
  const [DisplaySummary, setDisplaySummary] = useState(false);
  const [AllExpendituresDetails, setAllExpendituresDetails] = useState(
    props.Records
  );

  useEffect(() => {
    const getTheDetails = (TempArray) => {
      var Cash = 0;
      var POS = 0;
      var Transfer = 0;
      var TotalExp = 0;
      let Details = {};

      if (Array.isArray(TempArray) && TempArray.length > 0) {
        setThisExpenditures(TempArray);
        for (var f = 0; f < TempArray.length - 1; f++) {
          Cash +=
            TempArray[f].Account == "Cash"
              ? parseFloat(TempArray[f].Amount)
              : 0;
          POS +=
            TempArray[f].Account == "POS" ? parseFloat(TempArray[f].Amount) : 0;
          Transfer +=
            TempArray[f].Account == "Transfer"
              ? parseFloat(TempArray[f].Amount)
              : 0;
        }
        TotalExp = Cash + POS + Transfer;
        Details = {
          Cash: parseFloat(Cash),
          POS: parseFloat(POS),
          Transfer: parseFloat(Transfer),
          Expenditure: parseFloat(TotalExp),
        };
      }
      return Details;
    };
    if (props.myDates.type == "specific") {
      let ThisDetails = getTheDetails(
        AllExpendituresDetails.ThisExpenditureRecords
      );

      setTotalCash(isNaN(ThisDetails.Cash) ? 0 : ThisDetails.Cash);
      setTotalPOS(isNaN(ThisDetails.POS) ? 0 : ThisDetails.POS);
      setTotalTransfer(isNaN(ThisDetails.Transfer) ? 0 : ThisDetails.Transfer);
      setTotalExpenditure(
        isNaN(ThisDetails.Expenditure) ? 0 : ThisDetails.Expenditure
      );
      PCtx.UpdSpentCash(isNaN(ThisDetails.Cash) ? 0 : ThisDetails.Cash);
      PCtx.UpdSpentPOS(isNaN(ThisDetails.POS) ? 0 : ThisDetails.POS);
      PCtx.UpdSpentTransfer(
        isNaN(ThisDetails.Transfer) ? 0 : ThisDetails.Transfer
      );
    } else {
      let TempCash = 0;
      let TempPOS = 0;
      let TempTransfer = 0;
      let TempExpenditure = 0;
      for (var t = 0; t < AllExpendituresDetails.length; t++) {
        let TheDetails = getTheDetails(
          AllExpendituresDetails[t].ThisExpenditureRecords
        );
        TempCash += isNaN(TheDetails.Cash) ? 0 : TheDetails.Cash;
        TempPOS += isNaN(TheDetails.POS) ? 0 : TheDetails.POS;
        TempTransfer += isNaN(TheDetails.Transfer) ? 0 : TheDetails.Transfer;
        TempExpenditure += isNaN(TheDetails.Expenditure)
          ? 0
          : TheDetails.Expenditure;
      }
      setTotalCash(TempCash);
      setTotalPOS(TempPOS);
      setTotalTransfer(TempTransfer);
      setTotalExpenditure(TempExpenditure);
      PCtx.UpdSpentCash(TempCash);
      PCtx.UpdSpentPOS(TempPOS);
      PCtx.UpdSpentTransfer(TempTransfer);
    }
  }, []);

  const DeleteExpendiure = async (REC) => {
    let it = { ...REC, Username: PCtx.Username };
    let deleteexpenditure = await PCtx.connectAxios(
      "deletethisexpenditure.php",
      it
    );

    if (!deleteexpenditure.includes("Failure")) {
      PCtx.displayAlert(
        "Success",
        "Expendiure deleted successfully",
        "success"
      );
      PCtx.setReloadReport(!PCtx.ReloadReport);
    }
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      Array.isArray(ArrData.ThisExpenditureRecords) &&
      ArrData.ThisExpenditureRecords != undefined &&
      ArrData.ThisExpenditureRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }

    return (
      <Row className="justify-content-around mt-3" key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header>
              {" "}
              EXPENDITURE REPORT OF{" "}
              {Array.isArray(ArrData) ? ArrData.ThisDate.toUpperCase() : ""}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent && (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>EntryID</th>
                      <th>Amount</th>
                      <th>Given By</th>
                      <th>Given To</th>
                      <th>Purpose</th>
                      <th>From Which Account</th>
                      <th>Date Registered</th>
                      {props.myDates.Category === "Group" && <th>Del</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {ArrData.ThisExpenditureRecords.map((rec, index) => (
                      <tr key={index}>
                        <td>
                          {index < ArrData.ThisExpenditureRecords.length - 1
                            ? index + 1
                            : ""}
                        </td>
                        <td>{rec.EntryID}</td>
                        <td>{rec.Amount}</td>
                        <td>{rec.Giver}</td>
                        <td>{rec.Receiver}</td>
                        <td>{rec.Purpose}</td>
                        <td>{rec.Account}</td>
                        <td>{rec.DateRegistered}</td>

                        {props.myDates.Category === "Group" && (
                          <td>
                            <Button
                              className="btn-sm"
                              onClick={() => DeleteExpendiure(rec)}
                            >
                              -
                            </Button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const ExportToExcel = (ArrData, indx) => {
    return (
      <ExcelSheet
        data={ArrData.ThisExpenditures}
        name={ArrData.ThisDate}
        key={indx}
      >
        <ExcelColumn label="Receipt No" value="RID" />
        <ExcelColumn label="DATE_OF_TRANSACTION" value="DatePaid" />
        <ExcelColumn label="AMOUNT" value="Payable" />
        <ExcelColumn label="DISCOUNT" value="Discount" />
        <ExcelColumn label="PAID" value="Paid" />
        <ExcelColumn label="PAYMENT MODE" value="PaymentMode" />
        <ExcelColumn label="STAFF" value="Staff" />
        <ExcelColumn label="CUSTOMER" value="Customer" />
        <ExcelColumn label="PHONE" value="Phone" />
        <ExcelColumn label="PROFIT" value="Profit" />
      </ExcelSheet>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisExpenditures != undefined &&
      ArrData.ThisExpenditures.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase()}
        EXPENDITURE REPORTS FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent && (
          <Table
            striped
            bordered
            responsive
            key={indx}
            className={classes.table4printing}
          >
            <thead>
              <tr>
                <th>SN</th>
                <th>EntryID</th>
                <th>Amount</th>
                <th>Given By</th>
                <th>Given To</th>
                <th>Purpose</th>
                <th>Date Registered</th>
                {props.myDates.Category === "Group" && <th>Del</th>}
              </tr>
            </thead>
            <tbody>
              {ArrData.ThisExpenditures.map((rec, index) => (
                <tr key={index}>
                  <td>
                    {index < ArrData.ThisExpenditures.length - 1
                      ? index + 1
                      : ""}
                  </td>
                  <td>{rec.EntryID}</td>
                  <td>{rec.Amount}</td>
                  <td>{rec.Giver}</td>
                  <td>{rec.Receiver}</td>
                  <td>{rec.Purpose}</td>
                  <td>{rec.DateRegistered}</td>

                  <td>
                    <Button variant="outline-danger" className="btn-sm">
                      -
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        <Row className={classes.margin4printing}>
          {DisplayData && (
            <Row
              className={`${
                classes.margin4printing
              } ${"justify-content-around"}`}
            >
              <Col md={12} className={classes.hide4printing}>
                <p
                  style={{
                    fontFamily: "Times New Roman",
                    fontSize: "20px",
                    color: "brown",
                    textAlign: "center",
                  }}
                >
                  EXPENDITURES
                </p>
              </Col>

              <Col
                md={2}
                className={`${classes.hide4printing} ${classes.CardCol}`}
              >
                <Row className="justify-content-around mt-3">
                  <Col md={10} className={classes.CardCol}>
                    <Card>
                      <Card.Header className={classes.TheHeader}>
                        SUMMARY OF THE SELECTED DATE(S)
                      </Card.Header>
                      <Card.Body>
                        <Button
                          variant="info"
                          className="btn w-100 mt-2 mb-2 rounded-0"
                          onClick={() =>
                            setDisplaySummary(
                              (prevDisplaySummary) => !prevDisplaySummary
                            )
                          }
                        >
                          {DisplaySummary ? "Hide Summary" : "Display Summary"}
                        </Button>
                        <SummaryCard
                          Title="All Expenses "
                          Value={TotalExpenditure}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Total Cash Expenses "
                          Value={TotalCash}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Total POS Expenses "
                          Value={TotalPOS}
                          dispSum={DisplaySummary}
                        />
                        <br />
                        <SummaryCard
                          Title="Total Transfer Expenses "
                          Value={TotalTransfer}
                          dispSum={DisplaySummary}
                        />
                        <br />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col md={10} sm={12} xs={12} className={classes.margin4printing}>
                <Row
                  className={`${
                    classes.margin4printing
                  } ${"justify-content-around"}`}
                >
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.hide4printing}
                  >
                    <Accordion
                    // defaultActiveKey={
                    //   props.TableToShow > -1 ? props.TableToShow : null
                    // }
                    >
                      {props.myDates.type === "specific"
                        ? getTableCode(AllExpendituresDetails, 0)
                        : AllExpendituresDetails.map((rtrvrec, index) =>
                            getTableCode(rtrvrec, index)
                          )}
                    </Accordion>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.margin4printing}
                  >
                    {IsPrinting
                      ? props.myDates.type === "specific"
                        ? TableForPrinting(AllExpendituresDetails, 0)
                        : AllExpendituresDetails.map((rtrvrec, index) =>
                            TableForPrinting(rtrvrec, index)
                          )
                      : null}
                    {IsPrinting && (
                      <Row>
                        <Col md={2}>
                          <SummaryCard
                            Title="Total Cash Expenses "
                            Value={TotalCash}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Total POS Expenses "
                            Value={TotalPOS}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="Total Transfer Expenses"
                            Value={TotalTransfer}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard
                            Title="All Expenses"
                            Value={TotalExpenditure}
                          />
                        </Col>
                        <Col md={2}>
                          <SummaryCard Title="Payment by Transfer " Value="0" />
                        </Col>
                        <Col md={2}>
                          <SummaryCard Title="Payment by Credit " Value="0" />
                        </Col>
                        <Col md={2}>
                          <SummaryCard Title="Profit " Value="0" />
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <Button variant="info">Print</Button>
                  </Col>
                  <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                    <ExcelFile
                      element={
                        <Button variant="info" className="my-2">
                          EXPORT TO EXCEL
                        </Button>
                      }
                      filename={
                        Array.isArray(AllExpendituresDetails)
                          ? (props.myDates.Category === "Individual"
                              ? props.myDates.Staff.toUpperCase()
                              : "") +
                            " EXPENDITURE REPORT FOR " +
                            (props.myDates.type === "specific"
                              ? AllExpendituresDetails.ThisDate
                              : AllExpendituresDetails[0].ThisDate +
                                "-" +
                                AllExpendituresDetails[
                                  AllExpendituresDetails.length - 1
                                ].ThisDate
                            ).toUpperCase()
                          : ""
                      }
                    >
                      {props.myDates.type === "specific"
                        ? ExportToExcel(AllExpendituresDetails, 0)
                        : AllExpendituresDetails.map((rtvdata, ind) =>
                            ExportToExcel(rtvdata, ind)
                          )}
                    </ExcelFile>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default AllExpendituresAnalysis;
